import React from 'react';
import { Wifi, WifiOff, RefreshCw } from 'lucide-react';
import { useData } from '../contexts/DataContext';
import { useT } from '../lib/i18n';

export function SyncIndicator() {
  const { online, syncing, unsyncedCount, sync } = useData();
  const { t } = useT();

  let color = 'text-emerald-700 bg-emerald-50 border-emerald-200';
  let Icon = Wifi;
  let label = t('sync.online');
  if (!online) {
    color = 'text-gray-700 bg-gray-100 border-gray-300';
    Icon = WifiOff;
    label = t('sync.offline');
  } else if (syncing) {
    color = 'text-[#7A1F2B] bg-blue-50 border-blue-200';
    Icon = RefreshCw;
    label = t('sync.syncing');
  }

  return (
    <button
      data-testid="sync-indicator"
      onClick={() => online && sync()}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full border text-[11px] font-bold ${color}`}
    >
      <Icon size={12} className={syncing ? 'animate-spin' : ''} />
      <span>{label}</span>
      {unsyncedCount > 0 && (
        <span className="ml-1 px-1.5 bg-white/80 rounded-full text-[10px]">
          {unsyncedCount}
        </span>
      )}
    </button>
  );
}
